<div class="control-dus-page">
    <!-- Header de página -->
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">Control Documentos</h1>
                <p class="page-subtitle text-muted">
                    Gestión y seguimiento de documentación.
                </p>
            </div>
            <div class="header-actions">
                <button
                    mat-raised-button
                    color="accent"
                    (click)="exportarExcel()"
                    [disabled]="
                        isLoading || isGeneratingExcel || totalItems === 0
                    "
                    [matTooltip]="
                        isGeneratingExcel
                            ? 'Generando Excel...'
                            : totalItems === 0
                            ? 'No hay datos para exportar'
                            : 'Exportar registros del filtro actual a Excel (sin paginación)'
                    "
                >
                    <mat-icon>download</mat-icon>
                    Excel
                </button>
                <button
                    mat-raised-button
                    color="primary"
                    (click)="exportarReporteGuias()"
                    [disabled]="isLoading || isGeneratingReporteGuias || totalItems === 0"
                    [matTooltip]="
                        isGeneratingReporteGuias
                            ? 'Generando reporte...'
                            : totalItems === 0
                            ? 'No hay datos para exportar'
                            : 'Descargar Reporte de Guías de Despacho'
                    "
                >
                    <mat-icon>route</mat-icon>
                    Reporte Guías
                </button>
            </div>
        </div>
    </div>

    <!-- Stats de Control DUS -->
    <div class="stats-row">
        <mat-card
            class="trinta-card stat-card mb-25 bg-white border-none d-block"
        >
            <mat-card-content>
                <div class="d-flex align-items-center justify-content-between">
                    <div class="title">
                        <span class="d-block text-gray">Total DUS</span>
                        <h5 class="m-0">{{ formatearNumero(totalDus) }}</h5>
                    </div>
                    <div
                        class="icon d-flex align-items-center rounded-circle justify-content-center"
                    >
                        <i class="ri-file-list-3-line"></i>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- Gráficos de Control DUS (3 gráficos en la misma fila) -->
    <div class="charts-container">
        <app-control-dus-vencimiento-chart
            [statistics]="vencimientoStats"
        ></app-control-dus-vencimiento-chart>
        <app-control-dus-prorroga-chart
            [statistics]="prorrogaStats"
        ></app-control-dus-prorroga-chart>
        <app-control-dus-atraso-chart
            [statistics]="atrasoStats"
        ></app-control-dus-atraso-chart>
    </div>

    <!-- Filtros de búsqueda -->
    <mat-card class="filters-card">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>filter_list</mat-icon>
                Filtros de Búsqueda
            </mat-card-title>
        </mat-card-header>

        <mat-card-content>
            <div class="filters-section">
                <div class="filters-grid filters-grid-50">
                    <!-- Primera fila - 4 campos (igual que OS Agencia) -->
                    <!-- Campo para usuarios con rol cliente (input deshabilitado) -->
                    <mat-form-field
                        *ngIf="isClienteRole"
                        appearance="outline"
                        class="filter-field"
                    >
                        <mat-label>Cliente</mat-label>
                        <input
                            matInput
                            [formControl]="clienteControl"
                            placeholder="Cliente asignado"
                            readonly
                            inputmode="text"
                        />
                        <mat-icon matSuffix color="primary">business</mat-icon>
                    </mat-form-field>

                    <!-- Campo para consignatario (select filtrado) -->
                    <mat-form-field
                        *ngIf="isConsignatarioRole"
                        appearance="outline"
                        class="filter-field"
                    >
                        <mat-label>Cliente</mat-label>
                        <mat-select [formControl]="filtroClienteConsignatario">
                            <mat-option [value]="null">Todos los clientes</mat-option>
                            <mat-option
                                *ngFor="let c of clientesConsignatario"
                                [value]="c.clienteId"
                            >
                                {{ c.cliente }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>business</mat-icon>
                    </mat-form-field>

                    <!-- Campo para otros roles (autocomplete habilitado) -->
                    <mat-form-field
                        *ngIf="!isClienteRole && !isConsignatarioRole"
                        appearance="outline"
                        class="filter-field"
                    >
                        <mat-label>Cliente</mat-label>
                        <input
                            matInput
                            [formControl]="clienteControl"
                            [matAutocomplete]="autoCliente"
                            placeholder="Buscar cliente"
                            inputmode="search"
                        />
                        <mat-autocomplete
                            #autoCliente="matAutocomplete"
                            [displayWith]="mostrarCliente"
                            (optionSelected)="
                                onClienteSeleccionado($event.option.value)
                            "
                        >
                            <mat-option
                                *ngIf="isLoadingClientes"
                                class="loading-option"
                                disabled
                            >
                                <i
                                    class="ri-loader-4-line animate-spin me-2"
                                ></i>
                                Cargando clientes...
                            </mat-option>
                            <mat-option
                                *ngFor="
                                    let cliente of clientesFiltrados | async
                                "
                                [value]="cliente"
                            >
                                {{ cliente.cliente }}
                            </mat-option>
                            <mat-option
                                *ngIf="
                                    !isLoadingClientes &&
                                    (clientesFiltrados | async)?.length === 0
                                "
                                disabled
                            >
                                No se encontraron clientes
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>business</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Temporada</mat-label>
                        <mat-select [formControl]="filtroTemporada">
                            <mat-option [value]="null"
                                >Todas las temporadas</mat-option
                            >
                            <mat-option
                                *ngIf="temporadasOptions.length === 0"
                                disabled
                            >
                                Cargando temporadas...
                            </mat-option>
                            <mat-option
                                *ngFor="let temporada of temporadasOptions"
                                [value]="temporada.value"
                            >
                                {{ temporada.label }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>date_range</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Nave</mat-label>
                        <input
                            matInput
                            [formControl]="filtroNave"
                            [matAutocomplete]="autoNave"
                            placeholder="Buscar nave"
                            inputmode="search"
                        />
                        <mat-autocomplete
                            #autoNave="matAutocomplete"
                            [displayWith]="displayNave"
                        >
                            <mat-option [value]="''"
                                >Todas las naves</mat-option
                            >
                            <mat-option
                                *ngFor="let nave of filteredNavesOptions"
                                [value]="nave.vesselId"
                            >
                                {{ nave.vesselName }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-icon matSuffix>directions_boat</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Etapa</mat-label>
                        <mat-select
                            [(ngModel)]="filtroEtapa"
                            [ngModelOptions]="{ standalone: true }"
                        >
                            <mat-option [value]="null"
                                >Todas las etapas</mat-option
                            >
                            <mat-option *ngIf="etapas.length === 0" disabled>
                                Cargando etapas...
                            </mat-option>
                            <mat-option
                                *ngFor="let etapa of etapas"
                                [value]="etapa.value"
                            >
                                {{ etapa.label }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>timeline</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Estado</mat-label>
                        <mat-select
                            [(ngModel)]="filtroEstado"
                            [ngModelOptions]="{ standalone: true }"
                        >
                            <mat-option [value]="null"
                                >Todos los estados</mat-option
                            >
                            <mat-option *ngIf="estados.length === 0" disabled>
                                Cargando estados...
                            </mat-option>
                            <mat-option
                                *ngFor="let estado of estados"
                                [value]="estado.value"
                            >
                                {{ estado.label }}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix>flag</mat-icon>
                    </mat-form-field>

                    <!-- Segunda fila - 2 campos (igual que OS Agencia) -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Inicio</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerInicio"
                            [(ngModel)]="filtroFechaInicio"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Seleccionar fecha"
                            inputmode="none"
                            [disabled]="datesLocked"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerInicio"
                            [disabled]="datesLocked"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerInicio></mat-datepicker>
                        <mat-hint *ngIf="datesLocked">No disponible con Contenedor/DUS/Booking</mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Fin</mat-label>
                        <input
                            matInput
                            [matDatepicker]="pickerFin"
                            [(ngModel)]="filtroFechaFin"
                            [ngModelOptions]="{ standalone: true }"
                            placeholder="Seleccionar fecha"
                            inputmode="none"
                            [disabled]="datesLocked"
                        />
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="pickerFin"
                            [disabled]="datesLocked"
                        ></mat-datepicker-toggle>
                        <mat-datepicker #pickerFin></mat-datepicker>
                        <mat-hint *ngIf="datesLocked">No disponible con Contenedor/DUS/Booking</mat-hint>
                    </mat-form-field>

                    <!-- Tercera fila - 4 campos (similar a OS Agencia que tiene 5) -->
                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Ref. Cliente</mat-label>
                        <input
                            matInput
                            [(ngModel)]="filtroRefCliente"
                            placeholder="Referencia del cliente"
                            inputmode="text"
                        />
                        <mat-icon matSuffix>assignment</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Contenedor</mat-label>
                        <input
                            matInput
                            [ngModel]="filtroContenedor"
                            (ngModelChange)="filtroContenedor=$event; actualizarBloqueoFechas()"
                            placeholder="Número de contenedor"
                            inputmode="text"
                        />
                        <mat-icon matSuffix>inventory_2</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>DUS</mat-label>
                        <input
                            matInput
                            [ngModel]="filtroDus"
                            (ngModelChange)="filtroDus=$event; actualizarBloqueoFechas()"
                            placeholder="Número DUS"
                            inputmode="text"
                        />
                        <mat-icon matSuffix>description</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="filter-field">
                        <mat-label>Booking</mat-label>
                        <input
                            matInput
                            [ngModel]="filtroBooking"
                            (ngModelChange)="filtroBooking=$event; actualizarBloqueoFechas()"
                            placeholder="Número de booking"
                            inputmode="text"
                        />
                        <mat-icon matSuffix>confirmation_number</mat-icon>
                    </mat-form-field>
                </div>

                <!-- Botones de acción -->
                <div class="filter-actions">
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="aplicarFiltros()"
                        [disabled]="isLoading"
                        matTooltip="Buscar con los filtros aplicados"
                    >
                        <mat-icon>search</mat-icon>
                        Buscar
                    </button>
                    <button
                        mat-raised-button
                        color="warn"
                        (click)="limpiarFiltros()"
                        [disabled]="isLoading"
                        matTooltip="Limpiar todos los filtros"
                    >
                        <mat-icon>clear</mat-icon>
                        Limpiar
                    </button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Tabla de datos -->
    <mat-card class="data-card">
        <mat-card-content>
            <!-- Skeleton loading -->
            <app-skeleton-table
                *ngIf="isLoading"
                [columns]="skeletonColumns"
                [rows]="12"
            ></app-skeleton-table>

            <div class="control-dus-list-table" *ngIf="!isLoading">
                <div class="table-responsive">
                    <table
                        mat-table
                        [dataSource]="filteredDataSource"
                        matSort
                        (matSortChange)="onSortChange($event)"
                    >
                        <!-- Cliente Column (solo para no clientes) -->
                        <ng-container matColumnDef="cliente">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Cliente
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.cliente }}
                            </td>
                        </ng-container>

                        <!-- NroIE Column -->
                        <ng-container matColumnDef="nroIE">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Nro IE
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="nro-ie-number">{{
                                    element.nroIE || '-'
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- Ref Cliente Column -->
                        <ng-container matColumnDef="refCliente">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Ref. Cliente
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.refCliente || '-' }}
                            </td>
                        </ng-container>

                        <!-- Contenedor Column -->
                        <ng-container matColumnDef="contenedor">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Contenedor
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.contenedor || '-' }}
                            </td>
                        </ng-container>

                        <!-- PLTS Column -->
                        <ng-container matColumnDef="plts">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                class="text-end"
                            >
                                PLTS
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="text-end"
                            >
                                <span class="cantidad-plts">{{
                                    element.plts === null ||
                                    element.plts === undefined
                                        ? '-'
                                        : formatearNumero(element.plts)
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- DUS Column -->
                        <ng-container matColumnDef="dus">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                DUS
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="dus-number">{{
                                    element.dus || '-'
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- SPS Column -->
                        <ng-container matColumnDef="sps">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                                class="text-end"
                            >
                                SPS
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="text-end"
                            >
                                <span class="sps-number">{{
                                    element.sps || '-'
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- ISF Column -->
                        <ng-container matColumnDef="isf">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                ISF
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span class="isf-date">{{
                                    element.isf
                                        ? (element.isf | date : 'dd/MM/yyyy')
                                        : '-'
                                }}</span>
                            </td>
                        </ng-container>

                        <!-- Reserva Column -->
                        <ng-container matColumnDef="reserva">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Booking
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.reserva || '-' }}
                            </td>
                        </ng-container>

                        <!-- Tipo Embarque Column -->
                        <ng-container matColumnDef="tipoEmbarque">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Tipo
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="trinta-badge fw-medium d-inline-block"
                                >
                                    {{ element.tipoEmbarque || '-' }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Nave Column -->
                        <ng-container matColumnDef="nave">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Nave
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.nave || '-' }}
                            </td>
                        </ng-container>

                        <!-- POL Column -->
                        <ng-container matColumnDef="pol">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                POL
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.pol || '-' }}
                            </td>
                        </ng-container>

                        <!-- ETD Column -->
                        <ng-container matColumnDef="etd">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                ETD
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ formatearFecha(element.etd) }}
                            </td>
                        </ng-container>

                        <!-- POD Column -->
                        <ng-container matColumnDef="pod">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                POD
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.pod || '-' }}
                            </td>
                        </ng-container>

                        <!-- Etapa Column -->
                        <ng-container matColumnDef="etapa">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Etapa
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="trinta-badge fw-medium onHand d-inline-block"
                                    *ngIf="element.etapa === 'Legalización'"
                                >
                                    Legalización
                                </span>
                                <span
                                    class="trinta-badge fw-medium d-inline-block"
                                    *ngIf="element.etapa === 'Documentación'"
                                >
                                    Documentación
                                </span>
                                <span
                                    class="trinta-badge fw-medium d-inline-block"
                                    *ngIf="
                                        element.etapa &&
                                        element.etapa !== 'Legalización' &&
                                        element.etapa !== 'Documentación'
                                    "
                                >
                                    {{ element.etapa }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Estado Column -->
                        <ng-container matColumnDef="estado">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                mat-sort-header
                            >
                                Estado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="trinta-badge fw-medium danger d-inline-block"
                                    *ngIf="element.estado === 'Pendiente'"
                                >
                                    Pendiente
                                </span>
                                <span
                                    class="trinta-badge fw-medium warning d-inline-block"
                                    *ngIf="element.estado === 'En Proceso'"
                                >
                                    En Proceso
                                </span>
                                <span
                                    class="trinta-badge fw-medium onHand d-inline-block"
                                    *ngIf="element.estado === 'Finalizado'"
                                >
                                    Finalizado
                                </span>
                                <span
                                    class="trinta-badge fw-medium d-inline-block"
                                    *ngIf="
                                        element.estado &&
                                        element.estado !== 'Pendiente' &&
                                        element.estado !== 'En Proceso' &&
                                        element.estado !== 'Finalizado'
                                    "
                                >
                                    {{ element.estado }}
                                </span>
                            </td>
                        </ng-container>

                        <!-- Días Column -->
                        <ng-container matColumnDef="dias">
                            <th
                                mat-header-cell
                                *matHeaderCellDef
                                class="text-end"
                            >
                                Días
                            </th>
                            <td
                                mat-cell
                                *matCellDef="let element"
                                class="text-end"
                            >
                                {{ calcularDias(element) }}
                            </td>
                        </ng-container>

                        <!-- Semáforo Column -->
                        <ng-container matColumnDef="semaforo">
                            <th mat-header-cell *matHeaderCellDef>Semáforo</th>
                            <td mat-cell *matCellDef="let element">
                                <span
                                    class="semaforo-indicator"
                                    [class.semaforo-verde]="
                                        element.estado?.toLowerCase() ===
                                        'finalizado'
                                    "
                                    [class.semaforo-amarillo]="
                                        element.estado?.toLowerCase() ===
                                        'en proceso'
                                    "
                                    [class.semaforo-rojo]="
                                        element.estado?.toLowerCase() ===
                                        'pendiente'
                                    "
                                    [class.semaforo-gris]="
                                        element.estado?.toLowerCase() !==
                                            'finalizado' &&
                                        element.estado?.toLowerCase() !==
                                            'en proceso' &&
                                        element.estado?.toLowerCase() !==
                                            'pendiente'
                                    "
                                >
                                </span>
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef>ACCIONES</th>
                            <td mat-cell *matCellDef="let element">
                                <div class="action-buttons">
                                    <button
                                        mat-button
                                        color="primary"
                                        (click)="verDetalle(element)"
                                        matTooltip="Ver detalle del DUS"
                                        class="action-btn view-btn"
                                    >
                                        VER
                                    </button>
                                    <button
                                        mat-button
                                        color="primary"
                                        (click)="verPackingListsDesdeLista(element)"
                                        matTooltip="Ver Packing Lists"
                                        class="action-btn pkl-btn"
                                    >
                                        PKL
                                    </button>
                                    <button
                                        mat-button
                                        color="primary"
                                        (click)="exportarReporteGuiasPorDus(element)"
                                        matTooltip="Descargar Reporte de Guías de Despacho"
                                        class="action-btn gds-btn"
                                        [disabled]="isGeneratingReporteGuias"
                                    >
                                        GDS
                                    </button>
                                    <button
                                        mat-button
                                        color="accent"
                                        (click)="descargarDocumento(element)"
                                        matTooltip="Descargar documento"
                                        class="action-btn doc-btn"
                                    >
                                        DOC
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr
                            mat-header-row
                            *matHeaderRowDef="displayedColumns"
                        ></tr>
                        <tr
                            mat-row
                            *matRowDef="let row; columns: displayedColumns"
                        ></tr>
                    </table>
                </div>

                <!-- Mensaje cuando no hay datos -->
                <div
                    class="no-data"
                    *ngIf="filteredDataSource.length === 0 && !isLoading"
                >
                    <i class="ri-inbox-line"></i>
                    <p>
                        No se encontraron registros de Control DUS que coincidan
                        con los filtros aplicados.
                    </p>
                </div>

                <mat-paginator
                    class="control-dus-paginator"
                    [length]="totalItems"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    [pageIndex]="currentPage - 1"
                    (page)="onPageChange($event)"
                    showFirstLastButtons
                >
                </mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>

    <!-- Overlay de carga para generación de Excel -->
    <div *ngIf="isGeneratingExcel" class="excel-loading-overlay">
        <div class="excel-loading-content">
            <mat-spinner diameter="50"></mat-spinner>
            <p class="excel-loading-text">Generando Archivo Excel...</p>
        </div>
    </div>
</div>
